import type { ColumnConfig, TableRowData } from '../types';
import { ColumnDataTypes } from '../types';

export function resolveFilterOptions<TRow extends TableRowData>(
  column: ColumnConfig<TRow>
) {
  const isFilterable = column.filterable === true;
  if (!isFilterable) return undefined;

  const isTextColumn = column.dataType === ColumnDataTypes.TEXT;
  const isNumberColumn = column.dataType === ColumnDataTypes.NUMBER;

  return (
    column.filterOptions ??
    (isTextColumn
      ? { type: 'static' as const, options: [] }
      : isNumberColumn
        ? { type: 'static' as const, options: [] }
        : undefined)
  );
}

export function hasFilterOptions<TRow extends TableRowData>(
  column: ColumnConfig<TRow>
) {
  const isFilterable = column.filterable === true;
  if (!isFilterable) return false;

  const isDateColumn = column.dataType === ColumnDataTypes.DATE;
  const isTextColumn = column.dataType === ColumnDataTypes.TEXT;
  const isNumberColumn = column.dataType === ColumnDataTypes.NUMBER;
  const resolvedFilterOptions = resolveFilterOptions(column);

  return (
    isDateColumn ||
    isTextColumn ||
    isNumberColumn ||
    (resolvedFilterOptions &&
      (resolvedFilterOptions.type === 'static'
        ? resolvedFilterOptions.options.length > 0
        : true))
  );
}
